<template>
  <div>
    <label v-if="idLabel && !hiddenLabel">
      {{ idLabel }}
      <span v-if="isMandatory" class="color-red">* </span>
    </label>
    <div>
      <div class="dropdown" :id="'dropdownContact-' + randomId">
        <div> <!-- For selector with object as component value -->
          <input
            type="text"
            :disabled="disabled"
            :value="value"
            class="form-control inputAccordionForm"
            :class="errorIndicatorHighlight"
            :style="{height: customHeight !== 'none' ? customHeight + 'px' : 'calc(1.5em + 0.75rem + 2px)' }"
            :placeholder="placeholderValue"
            autocomplete="my-field-name"
            @click="resetSelection"
            @input="$emit('input', $event.target.value)">
          </input>
          <div
            v-show="showDropdownVisible()"
            class="dropdown-list" :style="dropdownStyle">
            <div
              v-for="item in itemListFiltered"
              :key="item.id"
              class="dropdown-item itemContact"
              @click="selectItem(item)"
              @mousedown="selectItem(item)">
              <div>
                <label>{{ item.name }}</label>
                <br/>
                <label>{{ item.identifier }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="mandatoryErrorIndicator" style="color:red;">
        {{ $t('errors.is_mandatory', {mandatoryValue :idLabel }) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormContactDropdownLabelInput',
  props: {
    customHeight: {
      type: String,
      default: 'none'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    idLabel: {
      type: String
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    mandatoryErrorIndicator: {
      type: Boolean,
      default: false
    },
    placeholderValue: {
      type: String
    },
    value: {
      default: ''
    }
  },
  data () {
    return {
      nbItemsShown: 0,
      randomId: Math.random().toString(36).substr(2, 10),
      timerId: '',
      showDropdown: false
    }
  },
  created () {
    window.addEventListener('click', this.handleClick)
    window.addEventListener('touchmove', this.handleClick)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.handleClick)
    window.removeEventListener('touchmove', this.handleClick)
  },
  methods: {
    focusBloc () {
      clearTimeout(this.timerID)
      this.showDropdown = true
    },
    handleClick (e) {
      if (e.target.closest('#dropdownContact-' + this.randomId)) {
        if (e.type === 'click' && e.target.closest('.itemContact')) {
          this.hideBloc()
        } else {
          this.focusBloc()
        }
      } else {
        this.hideBloc()
      }
    },
    itemVisible (item) {
      if (!this.showDropdown) {
        return false
      }
      // else if (this.value.toLowerCase() === item.name.toLowerCase()) {
      //   return false
      // }
      return item.name.toLowerCase().includes(this.value.toLowerCase())
    },
    hideBloc () {
      let that = this
      this.timerID = setTimeout(function () {
        that.showDropdown = false
      }, 100)
    },
    resetSelection () {
      // désactivé pour l'instant
      if (this) {
        return
      }
      this.$emit('input', '')
      this.$emit('change-iban', '')
      this.$emit('change-identifier', '')
      this.$emit('change-contact', {})
    },
    selectItem (selectedItem) {
      this.$emit('input', selectedItem.name)
      this.$emit('change-iban', selectedItem.iban)
      this.$emit('change-identifier', selectedItem.identifier)
      this.$emit('change-zonecode', selectedItem.zoneCode)
      this.$emit('change-contact', selectedItem)
    },
    showDropdownVisible () {
      return this.showDropdown && this.itemList.some(e => this.itemVisible(e))
    }
  },
  computed: {
    dropdownStyle () {
      if (this.nbItemsShown > 2) {
        return 'height:180px'
      }
    },
    errorIndicatorHighlight () {
      if (this.mandatoryErrorIndicator) {
        return 'errorBorder'
      }
      return ''
    },
    // Item list is the contacts list by default
    itemList () {
      return this.$engine.contacts.get()
    },
    itemListFiltered () {
      let listFiltered = this.itemList.filter(e => this.itemVisible(e))
      this.nbItemsShown = listFiltered.length
      return listFiltered
    }
  }
}
</script>

<style scoped>
.dropdown {
  position: relative;
  width: 100%;
  margin: 0;
}
.dropdown-input, .dropdown-selected {
  width: 100%;
  outline: none;
}
.dropdown-input:focus, .dropdown-selected:hover {
  background: #fff;
  border-color: #e2e8f0;
}
.dropdown-input::placeholder {
  opacity: 0.7;
  color: #333;
}
/* .dropdown-selected{
  cursor: pointer;
} */
.dropdown-list {
  position: absolute;
  z-index: 30000;
  width: 100%;
  margin-top: 4px;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}
.dropdown-item {
  display: flex;
  width: 100%;
  padding: 11px 16px;
  cursor: pointer;
}
.dropdown-item:hover {
  background: #edf2f7;
}
.dropdown-item-flag {
  max-width: 24px;
  max-height: 18px;
  margin: auto 12px auto 0px;
}

label {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// formContactDropdownLabelInput.vue?253702f2